import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon.vue';
import Vue from 'vue';
import Vuex from 'vuex';
import VeeValidate from 'vee-validate';
import App from './App.vue';
import router from './router';
import i18n from './locales';
import store from './store';
import VDynamicLoader from '@/components/DynamicLoader.vue';
import AuthProvider from './utils/auth';
import './registerServiceWorker';
import { EventBus } from './utils/event-bus';

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VeeValidate, { inject: false });

Vue.component('icon', Icon);
Vue.component('v-dynamic-loader', VDynamicLoader);

Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return EventBus;
    },
  },
  $auth: {
    get() {
      return new AuthProvider();
    },
  },
  // $permission: { // TODO Add PermissionService
  //   get() {
  //     return new PermissionService();
  //   },
  // },
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
